<template>
    <div class="location-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>你现在周围有楼房或其他建筑吗？</div>
        </div>
        <!--选项-->
        <div style="width:70px;margin:calc(0.073 * var(--body-height)) auto 0;">
            <el-radio-group v-model="building">
                <el-radio label="完全没有"></el-radio>
                <el-radio label="很少"></el-radio>
                <el-radio label="一般"></el-radio>
                <el-radio label="较多"></el-radio>
                <el-radio label="非常多"></el-radio>
            </el-radio-group>
        </div>
        <!--题目跳转-->
        <div class="subject-jump">
            <span @click="prevClick" class="prev-btn">{{ $t('preQues') }}</span>
            <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;"
                type="primary">{{ $t('nextQues') }} <i class="icon-right"></i> ({{ countNumber }}s)
            </el-button>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "building",
    data() {
        return {
            //是否有建筑
            building: '',
            timer: null,
            countNumber: 0
        }
    },
    computed: {
        ...mapGetters([
            'buildingAnswer',
            'codeItem'
        ]),
    },
    watch: {
        '$route': {
            immediate: true, // 组件创建时立即触发
            handler(newVal, oldVal) {
                this.$store.commit('SET_ANSWER_PERCENT', 17 * 100 / 22)
            }
        }
    },
    mounted() {
        this.countdown()
        this.building = this.buildingAnswer
    },
    methods: {

        /**
         * 上一题
         */
        prevClick() {
            this.$router.push('/nature3')
        },

        /**
         * 下一题
         */
        nextClick() {
            if (this.building == '') {
                this.$toast(this.$t('selectOne'));
                return;
            }
            //保存答案
            this.$store.commit('SET_BUILDING_ANSWER', this.building)
            this.codeItem[5][1] = this.building
           
            this.$router.push('/shop')
         
        },

        /**
         * 验证码倒计时
         */
        countdown() {
            let that = this;
            this.countNumber = 2;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(function () {
                if (that.countNumber === 0) {
                    clearInterval(this.timer);
                } else {
                    that.countNumber--;
                }
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
.location-back {
    height: 100%;
}
</style>
